module.exports = __webpack_public_path__ + "media/images/book-img-03-62929eea742c35327a00327fe00d5897.png";